<template>
  <b-card>
    <div slot="header">
      {{ $t('Persistent Menu') }}
      <div class="card-actions">
        <button class :title=" $t('New List')" :disabled="addStatus" @click.prevent="add">
          <font-awesome-icon icon="plus" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" v-if="call_to_actions.length">
        <tree
          v-for="(list, i) in call_to_actions"
          :key="`menu_list${id}${i}`"
          :id="`menu_list${id}${i}`"
          :parent="parent['call_to_actions'][i]"
          :level="level + 1"
          :data="list"
          @deleted="remove(call_to_actions, i)"
          :changed="handleOnChange"
          :index="i"
        ></tree>
      </div>
      <div class="col-sm-12">
        <tooltip label="text disabled" class="mb-0">
          <label class="switch switch-sm switch-text switch-info mb-0 ml-2">
            <input
              type="checkbox"
              v-model="composer_input_disabled"
              class="switch-input"
              v-on:change="handleOnChange"
            />
            <span class="switch-label" :data-on="$t('On')" :data-off="$t('Off')"></span>
            <span class="switch-handle"></span>
          </label>
        </tooltip>
      </div>
    </div>
  </b-card>
</template>
<script>
import {locales} from './shema'
import treeMixins from '../../mixins/tree'

export default {
	props: ['data', 'index', 'parent'],
	mixins: [treeMixins],
	data() {
		return {
			level: 0,
			locales: locales,
			locale: 'default',
			composer_input_disabled: this.data.composer_input_disabled,
			call_to_actions: this.data.call_to_actions || [],
		}
	},
	computed: {
        id() {
            return window.id()
        }
    },
	methods: {
		handleOnChange() {
			if (this.parent) {
				this.parent = Object.assign(this.parent, {
					locale: this.locale,
					composer_input_disabled: this.composer_input_disabled,
					call_to_actions: this.call_to_actions,
				})
				this.$emit('onMenuTreeChanged', this.index)
			}
        },
	},
	mounted() {},
}
</script>

<style lang="scss">
.tree--card {
	.card-body {
		padding-top: 0;
		padding-bottom: 0;
	}

	.card-header {
		border-bottom: unset;
		background-color: inherit;
		margin: 0.1rem;
		padding: 0.4rem 0.9rem;
		border: unset;
		height: 2rem;
		border-radius: unset;
		* button {
			border-left: unset;
			padding-top: 0.5rem;
			padding-bottom: 0.5rem;
			padding-right: 0.9rem;
			width: auto;
		}
	}
}
</style>
